import React from 'react';
import { format } from 'date-fns';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import { StatusIcon, StatusBadge } from '../ui';

const DashboardRequestCard = ({ 
  request, 
  onClick, 
  showDate = true,
  showFrom = true,
  variant = 'default' // 'default', 'compact', 'detailed'
}) => {
  const getFromValue = (request) => {
    if (request?.origin) {
      return 'Web';
    }
    return request.sender_email || 'N/A';
  };

  const baseClasses = "flex items-center justify-between p-3 rounded-lg transition-colors cursor-pointer border";
  
  const variantClasses = {
    default: "bg-gray-50 hover:bg-blue-50 border-gray-100",
    compact: "bg-white hover:bg-gray-50 border-gray-200",
    detailed: "bg-white hover:bg-indigo-50 border-gray-200 shadow-sm"
  };

  return (
    <div
      className={`${baseClasses} ${variantClasses[variant]}`}
      onClick={() => onClick?.(request.request_id)}
    >
      <div className="flex items-center space-x-2 sm:space-x-4">
        <StatusIcon status={request.front_status} />
        <div>
          <p className="font-medium text-gray-900 text-sm sm:text-base">Request #{request.request_id}</p>
          {showFrom && (
            <p className="text-xs sm:text-sm text-gray-500 truncate max-w-[150px] sm:max-w-full">
              From: {getFromValue(request)}
            </p>
          )}
        </div>
      </div>
      <div className="flex flex-col sm:flex-row items-end sm:items-center sm:space-x-4">
        <StatusBadge status={request.front_status} />
        {showDate && (
          <span className="text-xs sm:text-sm text-gray-500 mt-1 sm:mt-0 hidden sm:inline">
            {format(new Date(request.timestamp), 'MMM dd, yyyy')}
          </span>
        )}
        <ArrowRightIcon className="h-4 w-4 text-gray-400 mt-1 sm:mt-0" />
      </div>
    </div>
  );
};

export default DashboardRequestCard;